var map = {
	"./img-turfy-umajo-0.png": "f0af",
	"./img-turfy-umajo-2.png": "b23a",
	"./img-turfy-umajo-3.png": "a967",
	"./img-turfy-umajo-5.png": "7655"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e1b3";